/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const RelationshipType = {
    Acquaintance: 'Acquaintance',
    Parent: 'Parent',
    ExSpouse: 'ExSpouse',
    ExPartner: 'ExPartner',
    Spouse: 'Spouse',
    Child: 'Child',
    Partner: 'Partner',
    Other: 'Other',
    Unknown: 'Unknown',
    Relative: 'Relative'
} as const;
export type RelationshipType = typeof RelationshipType[keyof typeof RelationshipType];


export function instanceOfRelationshipType(value: any): boolean {
    for (const key in RelationshipType) {
        if (Object.prototype.hasOwnProperty.call(RelationshipType, key)) {
            if (RelationshipType[key as keyof typeof RelationshipType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function RelationshipTypeFromJSON(json: any): RelationshipType {
    return RelationshipTypeFromJSONTyped(json, false);
}

export function RelationshipTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RelationshipType {
    return json as RelationshipType;
}

export function RelationshipTypeToJSON(value?: RelationshipType | null): any {
    return value as any;
}

export function RelationshipTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): RelationshipType {
    return value as RelationshipType;
}

